import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Select, { CSSObjectWithLabel } from 'react-select';
import { useStore } from '../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { Task, activeOrderType, subTasks } from '../../app/api/types';

interface Props {
  selectedSubTaskId: string;
  setTemplateArray: any; //set state function
  setSubtaskIndexState: any; //set state function
  setTaskIndexState: any; //set state function
}

function AlertsMoveToOptions({
  selectedSubTaskId,
  setTemplateArray,
  setSubtaskIndexState,
  setTaskIndexState,
}: Props) {
  const {
    activityStore: { loadActivities, activityRegistry, selectedActivity },
    ElementStore,
    viewStore: { getActiveOrder, activeOrder },
  } = useStore();
  const { selectResolveSubtask } = ElementStore;
  const [sortedListItems, setSortedListItems] = useState<activeOrderType>();

  useEffect(() => {
    setSortedListItems(activeOrder);
    // eslint-disable-next-line
  }, [activeOrder]);

  useEffect(() => {
    if (activityRegistry.size <= 1) loadActivities();
  }, [activityRegistry.size, loadActivities]);

  useEffect(() => {
    getActiveOrder({ itemId: selectedActivity?.id });
    // eslint-disable-next-line
  }, [selectedActivity?.id]);

  const subTaskOptions = (
    subTasks: {
      subTaskId: string;
      subTaskName: string;
    }[],
  ) => {
    return subTasks.flatMap((subData) => {
      if (selectedSubTaskId === subData.subTaskId) return [];
      return {
        id: subData.subTaskId,
        value: `${subData.subTaskName} ${uuid()}`,
        label: `${subData.subTaskName}`,
      };
    });
  };

  const taskOptions = () => {
    const taskOptionsData: any = [];
    sortedListItems?.tasks?.forEach((item: any) => {
      if (item.isActive === true) {
        const taskOptions = {
          label: item.taskName,
          options: subTaskOptions(item.subTasks),
        };
        taskOptionsData.push(taskOptions);
      }
    });
    return taskOptionsData;
  };

  const selectSubtask = (e: any) => {
    setTemplateArray(sortedListItems);
    activeOrder?.tasks?.forEach((item: Task) => {
      item?.subTasks?.forEach((subData: subTasks) => {
        if (subData.subTaskId === e.id) {
          selectResolveSubtask({
            id: e.id + '|' + item.taskId,
            name: e.label,
          });
          setSubtaskIndexState(subData.subtaskIndex);
          setTaskIndexState(item.taskIndex);
        }
      });
    });
  };
  const Selects = (
    <Select
      options={taskOptions()}
      onChange={(e: any) => selectSubtask(e)}
      className="alertsmulti-select"
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (styles, _): CSSObjectWithLabel => {
          return {
            ...styles,
            zIndex: 9999,
          } as CSSObjectWithLabel;
        },
      }}
    />
  );

  return <>{sortedListItems && Selects}</>;
}

export default observer(AlertsMoveToOptions);
